import { render, staticRenderFns } from "./modal-checklist.vue?vue&type=template&id=156875be&scoped=true"
import script from "./modal-checklist.vue?vue&type=script&lang=js"
export * from "./modal-checklist.vue?vue&type=script&lang=js"
import style0 from "./modal-checklist.vue?vue&type=style&index=0&id=156875be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156875be",
  null
  
)

export default component.exports